import { ActionEnum } from '../enum/action.enum';
import { action } from 'mobx';
import { ActionFunction } from '../interface/action/action-function.type';
import { IRoutePayload } from '../interface/action/route-payload.interface';
import { getTemplateById } from '../util/action/type/get-template-by-id-action.util';
import { deleteDesignObjectDraft } from '../util/action/type/delete-design-object-draft-action.util';
import { EmailModel } from '../model/email.model';
import { WebDocumentModel } from '../model/web-document.model';
import { httpUpdateTemplate } from '../util/action/type/http-update-template-action.util';

export const updateTemplate$: ActionFunction<EmailModel | WebDocumentModel> = (action$, {state}) => {
  return action$
    .type(ActionEnum.UPDATE_TEMPLATE)
    .map((template) => {
      return [ httpUpdateTemplate(state.activeDesign.templateId, template), deleteDesignObjectDraft(template, false) ];
    });
};

export const loadDynamicTemplate$: ActionFunction<IRoutePayload> = (action$) => {
  return action$
    .type(ActionEnum.LOAD_DYNAMIC_TEMPLATE)
    .map(action((payload: IRoutePayload) => {
      return getTemplateById(payload.match.params.templateId);
    }));
};

export default {
  actions: [ loadDynamicTemplate$, updateTemplate$ ]
};
